.backdrop {
  background: transparent;
  height: 100vh;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  /* Above the app shell + sticky summary strip (z-index 40) and the
   * collab bottom action bar (z-index 38) / end-review dock (35), so the
   * user-menu dropdown can sit over them. Below modal overlays (2000). */
  z-index: 49;
}

.root {
  position: relative;
}

.trigger {
  align-items: center;
  background: none;
  border: 1px solid var(--color-border-strong);
  border-radius: 999px;
  cursor: pointer;
  display: flex;
  gap: 8px;
  height: 44px;
  justify-content: center;
  padding: 0;
  width: 44px;

  &:hover {
    background: var(--color-secondary);
    border-color: var(--color-foreground);
  }
}

.avatar {
  align-items: center;
  background: var(--color-accent);
  border-radius: 100px;
  color: var(--color-accent-foreground);
  display: flex;
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-weight: 600;
  height: 32px;
  justify-content: center;
  width: 32px;
}

.avatar-image {
  border-radius: 100px;
  height: 32px;
  object-fit: cover;
  width: 32px;
}

.chevron {
  color: var(--color-muted-fg);
  height: 14px;
  width: 14px;
}

.dropdown {
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  min-width: 220px;
  padding: 8px;
  position: absolute;
  right: 0;
  top: calc(100% + 8px);
  /* Matches the popover / tooltip / sidebar / slide-panel convention (50)
   * so the menu paints over sticky page chrome. Below modal overlays (2000). */
  z-index: 50;
}

.item {
  align-items: center;
  background: none;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  gap: 12px;
  padding: 12px 16px;
  text-align: left;
  width: 100%;

  &:hover {
    background: var(--color-secondary);
  }
}

.itemIcon {
  color: var(--color-muted);
  flex-shrink: 0;
  height: 18px;
  width: 18px;
}

.divider {
  background: var(--color-border);
  height: 1px;
  margin: 4px 8px;
}
